import React, { useEffect } from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { getDocContent } from 'actions/protocols';
import { bindActionCreators } from 'redux';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { createLoadingSelector, createErrorMessageSelector, ProtocolNumSelector } from 'selectors';
import { CIRB_ACTIONS, getEventDocs } from 'actions/protocols/cirb';
import { bindLogger } from 'helpers/BindLogger';
import { withAppContext } from '@ctsu/loader';
import PropTypes from 'prop-types';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { EventDocColumns } from '../gridcolumns';

const loadingSelector = createLoadingSelector([CIRB_ACTIONS.GET_EVENT_DOCS]);
const errorSelector = createErrorMessageSelector([CIRB_ACTIONS.GET_EVENT_DOCS]);

const EventDoc = ({ data, downloadDocHandler }) => (
  <GridTable
    tag={`${TE.ID}cirbeventdocs${TE.TABLE}`}
    title="CIRB Event Document(s)"
    exportTitle={`CIRB Event Document(s)-${useGetPathProtocol()}-CIRB`}
    columns={EventDocColumns}
    user={GetUserFullName()}
    rowEvents={[downloadDocHandler]}
    rows={data}
    enableToolbar
    filterable
    sortable
    recordPerPage={10}
    toPdf={false}
  />
);

export { EventDoc };


const EventDocuments = ({
  protocolNumber,
  onGetCIRBEventDocs,
  eventID,
  context,
  eventDocs,
  downloadDocHandler
}) => {
  useEffect(() => {
    if (_.isNumber(eventID)) {
      bindLogger(onGetCIRBEventDocs, context)(protocolNumber, eventID);
    }
  }, [eventID, onGetCIRBEventDocs, context, protocolNumber]);

  return (
    <EventDoc
      data={eventDocs.data}
      downloadDocHandler={downloadDocHandler}
    />
  );
};

EventDocuments.propTypes = {
  protocolNumber: PropTypes.string.isRequired,
  eventDocs: PropTypes.oneOfType([PropTypes.object]),
  downloadDocHandler: PropTypes.func.isRequired,
  eventID: PropTypes.number.isRequired,
  context: PropTypes.oneOfType([PropTypes.object]),
  onGetCIRBEventDocs: PropTypes.func.isRequired
};

EventDocuments.defaultProps = {
  eventDocs: null,
  context: null
};

const withConnectState = connect(
  (state, ownProps) => ({
    protocolNumber: ProtocolNumSelector(state),
    eventDocs: state.cirbData.eventDocs,
    isLoading: loadingSelector(state),
    iserror: errorSelector(state)
  }),
  dispatch => bindActionCreators(
    {
      onGetCIRBEventDocs: getEventDocs,
      onGetDocContent: getDocContent
    },
    dispatch
  )
);

const EventDocs = compose(
  withConnectState,
  withAppContext,
  withHandlers({
    downloadDocHandler: props => docId => {
      const { context, onGetDocContent } = props;
      bindLogger(onGetDocContent, context)(docId);
    }
  })
)(EventDocuments);
export default EventDocs;
